const width = document.body?.clientWidth ?? window.screen?.width ?? 1440 ; 
const quality = width > 700 ? 'HD': 'SD';


const join=(...args)=>(args.join(' '));

const getPrice = ( val ) => Number( val ) / 100 ;

const setBodyStyle = ( { overflow } ) => {
    const body = document.body ?? document.querySelector('html > body ') ;
    if(!body) return false;

    body.style.overflow = overflow;

    return true;
}



const getImageUrl = ( posters = [] ) => posters.reduce( ( acc, poster )=>{
    if( !acc ) return poster.url ;
    else if( poster.quality === quality ) return poster.url ;
    else return acc ;
}, '')


const getErrorText = ( errors ) => {
    for ( let prop in errors ){
      const message = errors[ prop ]?.message ;
      if( message ) return message ;
    }
}

const getTitleCase = (text) => {
    return text.charAt(0).toUpperCase()+text.substr(1).toLowerCase()
}

const notZero = (n) =>{
    n = +n;  // Coerce to number.
    if (!n) {  // Matches +0, -0, NaN
      throw new Error('Invalid dividend ' + n);
    }
    return n;
  }

const processNodeToList = ( node, prop, ignoreList = [] ) => {
    if( !node ) return [] ;

    let data = []; 
   
    for( let key in node ) {
        if( ignoreList.includes( key ) ) continue ;
        let nodeData = node[ key ] ;
        if( !( nodeData instanceof Object) )continue;
        nodeData[ prop ] = key ;
        data.push( nodeData );
    }

    return data ;
}

const CryptoJS = require("crypto-js");

const encode_url=(data)=> {
    data = data.replace(/\+/g, "-");
    data = data.replace(/\//g, "_");
    data = data.replace(/\=/g, ",");

    return data;
}

const encryptData =(plainData, key)=> {
    var C = CryptoJS;
    var plainText = C.enc.Utf8.parse(plainData);
    key = C.enc.Utf8.parse(key);
    var aes = C.algo.AES.createEncryptor(key, {
      mode: C.mode.ECB,
      padding: C.pad.Pkcs7,
      iv: key,
    });
    var encrypted = aes.finalize(plainText);
    encrypted = C.enc.Base64.stringify(encrypted);
    encrypted = encode_url(encrypted);
    return encrypted;
}

const sendMobioticsAnalytics= (data, configuration )=>{

    const dataString = JSON.stringify(data);
    const hashedData = CryptoJS.SHA1(dataString);
    const vendorkey =  configuration?.vendorDetails?.vendorKey
    const vendorid =  configuration?.vendorDetails?.vendorId
    const baseUrl = configuration?.vendorDetails?.baseUrl
    const body = encryptData(dataString, vendorkey);
    const url = baseUrl + "/analytics/v2/analytics?vendorid=" + vendorid + "&hash=" + hashedData;
    console.log('navogator:', hashedData, body, url)
    const formData = new FormData();
    formData.append("encdata", body);

    const result = navigator.sendBeacon(url, body);

    return result;

}

const zeroPrefix = (n) => {
    return (n < 10) ? ('0' + n) : n.toString();
};

const nowtoDateConversion = (getUnixTime) =>{
    const getDate = new Date(getUnixTime);
    const getYear = getDate.getUTCFullYear();
    const getMonth = zeroPrefix(getDate.getUTCMonth()+1);
    const getDateNow = zeroPrefix(getDate.getUTCDate());
    const getHour = zeroPrefix(getDate.getUTCHours());
    const getMinutes = zeroPrefix(getDate.getUTCMinutes());
    const getSeconds = zeroPrefix(getDate.getUTCSeconds());
    const getFullDate = `${getYear}-${getMonth}-${getDateNow} ${getHour}:${getMinutes}:${getSeconds}`;
    return getFullDate;
}

const  shallowEqual = (object1, object2)=> {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
      return false;
    }
    for (let key of keys1) {
      if (object1[key] !== object2[key]) {
        return false;
      }
    }
    return true;
  }

export {
    join, 
    getPrice,
    setBodyStyle,
    getImageUrl,
    getErrorText,
    getTitleCase,
    notZero,
    processNodeToList,
    sendMobioticsAnalytics,
    nowtoDateConversion,
    shallowEqual
}